<template>
  <div class="page">
    <div class="app-container">
      <BaseSearch
        v-model="searchForm"
        :formOptions="searchOption"
        @handleSearch="handleSearch"
      >
        <el-button type="primary" @click="handleDictAdd">+ 新增</el-button>
        <el-button type="primary" @click="handleClass">字典分类</el-button>
      </BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/dict/index"
        :tableData.sync="tableData"
        :columns="columns"
        :paramsCepCallback="paramsCepCallback"
        :searchParams="searchForm"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="primary" size="mini" @click="edit(row)"
            >编辑</el-button
          >
          <el-button type="danger" size="mini" @click="del(row)"
            >删除</el-button
          >
        </template>
      </BaseTable>
      <BaseDrawer :visible.sync="drawerVisible" :title="drawerTitle">
        <div class="class-head">
          <el-input
            type="text"
            placeholder="请输入类别"
            v-model="classifyForm.typeName"
          ></el-input>
          <el-button
            class="ml15"
            type="primary"
            :loading="classifyLoading"
            @click="handleClassifyAdd"
            >+ 新增</el-button
          >
        </div>
        <div class="class-body">
          <BaseTable
            ref="classifyTable"
            url="/admin/dicttype/index"
            :tableData.sync="classifyData"
            :columns="classColumns"
          >
            <template #name="{ row, column, index }">
              <div v-if="index !== editIndex">
                {{ row[column.property] }}
              </div>
              <div v-else>
                <el-input v-model="row.typeName" type="text"></el-input>
              </div>
            </template>
            <template #custom="{ row, index }">
              <div v-if="index !== editIndex">
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleClassifyEdit(row, index)"
                >
                  编辑
                </el-button>
                <el-button
                  type="danger"
                  size="mini"
                  @click="handleClassDel(row)"
                  class="ite"
                >
                  删除
                </el-button>
              </div>
              <div v-else>
                <el-button
                  type="primary"
                  size="mini"
                  @click="handleClassifySave(row)"
                >
                  保存
                </el-button>
              </div>
            </template>
          </BaseTable>
        </div>
      </BaseDrawer>
      <BaseDialog
        :visible.sync="dialogVisible"
        :title="dialogTitle"
        @confirm="handleDialogConfirm"
      >
        <BaseForm
          ref="baseForm"
          v-model="formData"
          :formOptions="dictFormOption"
          :rules="rules"
          itemWidth="100%"
        ></BaseForm>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import {
  columns,
  classColumns,
  searchOption,
  dictFormOption,
  rules,
} from './config';
export default {
  name: 'Dictionaries',
  comments: {},
  data() {
    return {
      // 抽屉相关
      drawerVisible: false,
      drawerTitle: '字典类别',
      // 字典相关
      tableData: [],
      searchForm: {},
      formData: {
        dictType: '',
      },
      // 字典类别相关
      classOptions: [],
      editIndex: -1,
      classifyForm: {
        typeName: '',
      },
      classifyData: [],
      classifyLoading: false,
      // 弹框相关
      dialogVisible: false,
      dialogTitle: '',
      // 校验相关
      rules: rules(this),
    };
  },
  computed: {
    columns,
    classColumns,
    searchOption,
    dictFormOption,
  },
  created() {
    this.getClassList();
  },
  methods: {
    initClassify() {
      this.classifyForm = {};
    },
    initDict() {
      this.formData = {};
      this.$refs?.baseForm?.resetFields();
    },
    // 获取分类列表
    async getClassList() {
      const res = await this.$api.post('/admin/dicttype/index');
      this.classOptions = res.data.data.map((item) => ({
        ...item,
        label: item.typeName,
        value: item.id,
      }));
    },
    /**
     * 字典相关
     */
    // 点击搜索
    handleSearch() {
      this.$refs.baseTable.searchData();
    },

    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
      };
    },

    // 点击添加字典
    handleDictAdd() {
      this.dialogVisible = true;
      this.dialogTitle = '新增字典';
      this.dialogFlag = 'add';
      this.initDict();
      this.getClassList();
    },

    // 点击编辑字典
    edit(row) {
      this.dialogVisible = true;
      this.formData = { ...row };
      this.dialogFlag = 'edit';
    },

    // 字典删除
    async del({ id }) {
      const confrim = await this.$confirm('是否确认删除', '提示', {
        type: 'error',
      });
      if (confrim) {
        await this.$api.post('/admin/dict/del', { id }, '删除');
        this.handleSearch();
      }
    },

    /**
     * 字段分类相关
     */
    // 搜索字典分类
    handleClassifySearch() {
      this.$refs.classifyTable.searchData();
    },

    // 点击字典分类
    handleClass() {
      this.drawerVisible = true;
      this.drawerTitle = '字典类别';
      this.initClassify();
    },

    // 点击新增分类
    async handleClassifyAdd() {
      if (!this.classifyForm.typeName) {
        this.$message.warning('请输入分类名称');
        return;
      }
      this.classifyLoading = true;
      await this.$api
        .post('/admin/dicttype/save', { ...this.classifyForm }, '新增分类')
        .catch(() => {
          this.classifyLoading = false;
        });
      this.classifyLoading = false;
      this.handleClassifySearch();
    },

    // 点击分类编辑
    async handleClassifyEdit(row, index) {
      this.editIndex = index;
    },

    // 点击分类删除
    async handleClassDel(row) {
      const confirm = await this.$confirm('是否确认删除', '提示', {
        type: 'warning',
      }).catch(() => {});
      console.log(confirm);
      if (!confirm) return;
      await this.$api.post('/admin/dicttype/del', { ...row }, '删除');
      this.handleClassifySearch();
    },

    // 点击分类保存
    async handleClassifySave(row) {
      await this.$api.post('/admin/dicttype/save', { ...row }, '保存');
      this.editIndex = -1;
      this.handleClassifySearch();
    },
    /**
     * 分类相关结束
     */

    // 抽屉内容提交
    handleDialogConfirm(cb) {
      const msg = this.dialogFlag === 'add' ? '添加字典' : '编辑字典';
      // 用来结束loading
      this.$refs.baseForm.onSubmit(async (validate) => {
        if (validate) {
          const confirm = await this.$confirm('是否确认提交？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).catch(() => {});
          if (confirm) {
            await this.$api.post('/admin/dict/save', { ...this.formData }, msg);
            this.dialogVisible = false;
            this.handleSearch();
          }
          cb(false);
        } else {
          cb();
        }
      });
    },
  },
};
</script>
<style>
// 分类相关
.class-head {
  display: flex;
  align-items: center;
}
</style>
